var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 22,
    width: 22,
    height: 20,
    rx: 5,
    transform: "rotate(180 23 22)",
    fill: "none",
    className: "fill"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1701_11704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7384 16.5779H5.70464C5.49367 16.5779 5.32068 16.4049 5.32068 16.1939L5.32068 10.1939L4.08439 11.4302C3.93671 11.5779 3.69198 11.5779 3.54431 11.4302L2.11393 9.9914C1.96625 9.84372 1.96625 9.599 2.11393 9.45132L6.45148 5.10955C6.59494 4.96609 6.8481 4.96609 6.99156 5.10955L11.3333 9.45132C11.481 9.599 11.481 9.84372 11.3333 9.9914L9.89452 11.426C9.74684 11.5737 9.50211 11.5737 9.35443 11.426L8.11814 10.1897L8.11814 16.1939C8.11814 16.4049 7.94515 16.5779 7.73418 16.5779H7.7384ZM6.08861 15.81H7.35443V9.26989C7.35443 9.11377 7.44726 8.97453 7.59072 8.91545C7.73418 8.85638 7.89874 8.89014 8.00844 8.99984L9.62447 10.6159L10.519 9.72136L6.72574 5.91967L2.92405 9.72136L3.81857 10.6159L5.4346 8.99984C5.54431 8.89014 5.70886 8.85638 5.85232 8.91545C5.99578 8.97453 6.08861 9.11377 6.08861 9.26989V15.8142V15.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2911 16.5779H16.2574C16.0464 16.5779 15.8734 16.4049 15.8734 16.1939L15.8734 10.1939L14.6371 11.4302C14.4895 11.5779 14.2447 11.5779 14.097 11.4302L12.6582 9.99562C12.5106 9.84794 12.5106 9.60322 12.6582 9.45554L17.0042 5.10955C17.1477 4.96609 17.4008 4.96609 17.5443 5.10955L21.8861 9.45132C22.0338 9.599 22.0338 9.84372 21.8861 9.9914L20.4515 11.426C20.3038 11.5737 20.0591 11.5737 19.9114 11.426L18.6751 10.1897V16.1939C18.6751 16.4049 18.5021 16.5779 18.2911 16.5779ZM16.6414 15.81H17.9072V9.26989C17.9072 9.11377 18 8.97453 18.1435 8.91545C18.2869 8.85638 18.4515 8.89014 18.5612 8.99984L20.1772 10.6159L21.0717 9.72136L17.2743 5.91967L13.4768 9.71714L14.3713 10.6117L15.9873 8.99562C16.097 8.88592 16.2616 8.85216 16.4051 8.91124C16.5485 8.97031 16.6414 9.10955 16.6414 9.26567V15.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.616 18.9369L2.38397 18.9369C2.173 18.9369 2 18.7639 2 18.5529C2 18.3419 2.173 18.1689 2.38397 18.1689L21.616 18.1689C21.827 18.1689 22 18.3419 22 18.5529C22 18.7639 21.827 18.9369 21.616 18.9369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1701_11704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.9367,
    fill: "white",
    transform: "translate(2 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOrder);
export default __webpack_public_path__ + "static/media/sales-order.33af34b7.svg";
export { ForwardRef as ReactComponent };